export default __webpack_public_path__ + "static/media/hht2_ep3_speaking_01.aebbc8bc.png";